import { Edit as EditIcon } from "@mui/icons-material"

const PaymentSummaryCard = ({ subscription, onAction }) => {
	const isLinkAction = subscription?.primaryAction?.type === 'mailto' && subscription?.primaryAction?.href
	const ActionTag = isLinkAction ? 'a' : 'button'
	const actionProps = isLinkAction
		? {
			href: subscription?.primaryAction?.href,
			className: 'scout-payments-summary-card__action',
		}
		: {
			type: 'button',
			className: 'scout-payments-summary-card__action',
			onClick: () => onAction?.(subscription?.primaryAction),
		}

	return (
		<div className="scout-settings-card scout-payments-summary-card">
			<div className="scout-payments-summary-card__header">
				<div className="scout-payments-summary-card__meta">
					<strong>{subscription?.name}</strong>
					<span>{subscription?.details}</span>
				</div>
				<div className="scout-payments-summary-card__price-block">
					<strong>{subscription?.price}</strong>
					<span>{subscription?.renewalLabel}</span>
				</div>
				<ActionTag {...actionProps}>
					<EditIcon fontSize="small" />
					<span className="scout-payments-action-label--desktop">{subscription?.primaryAction?.label}</span>
					<span className="scout-payments-action-label--mobile">{subscription?.primaryAction?.mobileLabel ?? subscription?.primaryAction?.label}</span>
				</ActionTag>
			</div>
		</div>
	)
}

export default PaymentSummaryCard